/* Journal listing only: use the theme's existing reveal CSS after final cards
 * arrive. No shuffle, pagination, article content, or view-count changes.
 * Cards stay visible if JavaScript or IntersectionObserver is unavailable.
 */
(() => {
  function start() {
    if (window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof IntersectionObserver === 'undefined') return;

    document.querySelectorAll('[data-journal-scroll-reveal]').forEach((host) => {
      const grid = host.querySelector('.sd-journal__grid');
      if (!grid) return;
      const initialized = new WeakSet();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('scroll-trigger--offscreen');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -50px 0px' });

      function revealCards() {
        // Native cards are replaced during the asynchronous All articles shuffle.
        // Wait for its ready state or its existing visible-content fallback.
        if (grid.dataset.journalShuffle === 'true' &&
            !['ready', 'unavailable'].includes(grid.dataset.journalShuffleState)) return;
        const columns = Math.max(1, getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length);
        grid.querySelectorAll('.sd-journal__card').forEach((card, index) => {
          if (initialized.has(card)) return;
          initialized.add(card);
          card.style.setProperty('--animation-order', index % columns);
          card.classList.add('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          observer.observe(card);
        });
      }

      grid.addEventListener('journal:articles-reordered', revealCards);
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(revealCards).observe(grid, {
          attributes: true, attributeFilter: ['data-journal-shuffle-state'], childList: true,
        });
      }
      window.addEventListener('pageshow', revealCards);
      revealCards();
    });
  }

  // Run after the theme's initial DOMContentLoaded observer has been attached;
  // it must not also observe cards that this scoped observer owns.
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
